import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../widgets/Head';
import { Hero } from '../widgets/Hero';
import * as css from './About.m.css';
import { Link } from '@dojo/framework/routing/Link';
import { ConnectStrip } from '../widgets/ConnectStrip';
import ContentWrapper from '../widgets/ContentWrapper';
import Section from '../widgets/Section';
import Text from '../widgets/Text';

const integrityImg = require('../assets/images/icon-illustration/integrity.svg');
const knowledgeImg = require('../assets/images/icon-illustration/knowledge.svg');
const respectImg = require('../assets/images/icon-illustration/respect.svg');

const factory = create();

export const About = factory(function About() {
	return (
		<div classes={css.root}>
			<Head
				title="About SitePen - A Leading Web App Development Company"
				description="Learn more about SitePen, a leading web engineering consultancy based in the US with more than two decades of experience developing enterprise-grade solutions."
			/>
			<Hero background="level1BluePurple" align="center" blurbWidth="md" paddingBottom="xs">
				{{
					xlTitle: 'About Us',
					blurb: (
						<Text type="large-body">
							<p>
								SitePen is a leading strategic consultancy based in the USA. Our
								company is committed to achieving technical objectives, solving
								critical business problems, and{' '}
								<Link to="work">helping our customers build web applications</Link>{' '}
								the right way, the first time.
							</p>
							<p>
								With nearly two decades of experience developing software, we
								believe the Enterprise has more opportunities than ever to gain
								efficiencies across the organization, given the acceptance and
								adoption of new approaches to technology, lean process, and the
								evolving open web. We are ready to help your organization realize
								its potential and achieve desired and predictable results.
							</p>
						</Text>
					)
				}}
			</Hero>
			<Section type="leading">
				<ContentWrapper size="smaller">
					<Text type="section">Our Philosophy</Text>
					<Text type="body">
						Our people are our success. We bring together the expertise and experience
						of talented professionals who are born to solve problems, move with purpose,
						and develop elegant, pragmatic solutions to every challenge. To attract and
						retain these amazing people, we strive to uphold three core values:
					</Text>
					<ul classes={css.list}>
						<li classes={css.item}>
							<div classes={css.leading}>
								<img classes={css.img} src={knowledgeImg} alt="" />
							</div>
							<div>
								<Text type="subhead">Knowledge</Text>
								<Text type="body">
									Our continuous focus on learning, research, and experimentation
									allows us to hone all aspects of our approach to lean
									application development.
								</Text>
							</div>
						</li>
						<li classes={css.item}>
							<div classes={css.leading}>
								<img classes={css.img} src={respectImg} alt="" />
							</div>
							<div>
								<Text type="subhead">Respect</Text>
								<Text type="body">
									We nurture a team culture that promotes a healthy, sustainable
									work-life balance, one that is always supportive and respectful
									of everyone with whom we interact.
								</Text>
							</div>
						</li>
						<li classes={css.item}>
							<div classes={css.leading}>
								<img
									loading="lazy"
									classes={[css.img, css.integrityImg]}
									src={integrityImg}
									alt=""
								/>
							</div>
							<div>
								<Text type="subhead">Integrity</Text>
								<Text type="body">
									We never price an engagement to win business. We strive to sell
									our services in a way that balances honesty and effort with the
									exceptional capabilities of our team.
								</Text>
							</div>
						</li>
					</ul>
					<Text type="body">
						Whether you need a phased approach to modernizing your apps, tools and teams
						or are building a brand-new product, we are proud to offer true{' '}
						<Link to="expertise">enterprise expertise</Link>, industry leadership, a
						great customer experience, predictability and dedicated partnership to help
						you reach your goals and take on the next ones.
					</Text>
				</ContentWrapper>
			</Section>
			<Section type="trailing" shaded>
				<ConnectStrip trailing />
			</Section>
		</div>
	);
});

export default About;
